// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"Text_textWrapper__ijD1j","scale":"Text_scale__muLpD"};